import React from "react";
import Layout from "./layout.js";
import Breadcrumbs from "../component/Breadcrumbs.js";
import SectionHeading from "../component/SectionHeading.js";
import IconCard from "../component/IconCard.js";
import * as Constants from "../config/constants.js";
import innovationIcon from "../assets/images/innovation.svg";
import turnAroundIcon from "../assets/images/turn-around.svg";
import investmentIcon from "../assets/images/investment.svg";
import esgStrategyIcon from "../assets/images/esg-strategy.svg";
import strategicAgendaIcon from "../assets/images/strategic-agenda.svg";
import marketSizingIcon from "../assets/images/market-sizing.svg";
import marketAssessmentIcon from "../assets/images/market-assessment.svg";
import voiceOfCustomerIcon from "../assets/images/voice-of-customer.svg";
import competitiveAnalysisIcon from "../assets/images/competitive-analysis.svg";
import benchmarkingIcon from "../assets/images/benchmarking.svg";
import macroEnviromentIcon from "../assets/images/macro-enviroment.svg";
import valueRiskIcon from "../assets/images/value-risk.svg";
import strategicDueIcon from "../assets/images/strategic-due.svg";
import synergyAnalysisIcon from "../assets/images/synergy-analysis.svg";
import operationalService1 from "../assets/images/operational-service1.png";
import operationalService2 from "../assets/images/operational-service2.png";
import operationalService3 from "../assets/images/operational-service3.png";
import operationalService4 from "../assets/images/operational-service4.png";
import ops_casestudy2_img1 from "../assets/images/ops_casestudy2_img1.png";
import ops_casestudy2_img2 from "../assets/images/ops_casestudy2_img2.png";
import ops_casestudy2_img3 from "../assets/images/ops_casestudy2_img3.png";
import ops_casestudy3_img1 from "../assets/images/ops_casestudy3_img1.png";
import ops_casestudy3_img2 from "../assets/images/ops_casestudy3_img2.png";
import ops_casestudy3_img3 from "../assets/images/ops_casestudy3_img3.png";
import Fancybox from "../assets/js/fancybox.js";

export default function OperationalExcellence({pageName}) {

  // ✅ IMPORTANT: update this slug to match your real route
  const canonicalUrl = `${Constants.SITE_URL}/services/operational-excellence/`;

  // ✅ SEO override for this page
  const seoData = {
    seo_title: pageName,
    seo_description:
      "Operational excellence delivered through hybrid delivery model consulting, consulting execution support, process optimization, supply chain improvement, and end-to-end consulting solutions for boutique consulting firms and independent consultants.",
    seo_keywords:
      "scaling consulting business, boutique consulting firms, independent consultants, consulting execution partner, hybrid delivery model consulting, consulting lifecycle management, end-to-end consulting solutions, consulting delivery framework, implementation consulting services, consulting PMO services, consulting project management, consulting execution support, managed delivery teams consulting, consulting capacity management, consulting outsourcing",
    canonical_url: canonicalUrl,
  };

  return (
    <Layout pageName={pageName} seoData={seoData} pageUrl={canonicalUrl}>
      <Breadcrumbs title="Services" text="Operational excellence delivery for boutique consulting firms" />

      <section className="consult-outcome-sec sec-padding">
        <div className="container">
          <SectionHeading headingClassName="full-text" secName="Consulting Outcomes" secText="We deliver end-to-end consulting outcomes…" />

          <div className="card-row row justify-content-center">
            <IconCard lg="3" md="4" col="6" className="border-card" icon={marketAssessmentIcon} title="Delivery excellence strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={innovationIcon} title="New Product Development"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={strategicDueIcon} title="Delivery Management Strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={voiceOfCustomerIcon} title="Distribution strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={investmentIcon} title="Working Capital reduction strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={marketSizingIcon} title="Supply Chain excellence (inbound & outbound)"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={synergyAnalysisIcon} title="Business Process re-engineering (BPR)"/>
          </div>
        </div>
      </section>

      <section className="project-input-sec sec-padding">
        <div className="container">
          <SectionHeading headingClassName="full-text" secName="Consuling Workstreams" secText="…and the foundational analysis that makes them possible:" />

          <div className="card-row row justify-content-center">
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={strategicAgendaIcon} title="Service Quality assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={valueRiskIcon} title="Inventory portfolio analysis"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={voiceOfCustomerIcon} title="Distribution effectiveness assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={macroEnviromentIcon} title="Production Planning analysis"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={competitiveAnalysisIcon} title="New product development process analysis"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={esgStrategyIcon} title="Process Mapping"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={turnAroundIcon} title="Consulting Project Management"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={benchmarkingIcon} title="Program Management"/>
          </div>
        </div>
      </section>

      {/* 01 */}
      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Detailed Operating Model Design for Museums in Saudi Arabia</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">Museums Commission under Ministry of Culture, KSA</li>
                  <li className="p-text">A leading strategic advisory and investments firm, based in Riyadh</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">An operating model for storage and maintenance department of museums i.e., processes and procedures, organization structure, role & responsibilities and operating guidelines for storage of articles and others</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">Analyzed the typology of museum articles part of the collection, and categorized them basis globally accepted naming standards and guidelines</li>
                  <li className="p-text">Undertook market research to identify global standards and industry best practices for storage and maintenance of museum articles</li>
                  <li className="p-text">Conducted client workshops to design target operating model - high-level business cycles, procedures and processes for operations</li>
                  <li className="p-text">Delivered documents for operationalization of museums - Operating Manual, Training Manual, Authority Matrix, Process Workflows</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <div className="content key-project-content">
                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={operationalService1} alt="operationalService1" className="img" /></div>
                        <li className="p-text">High-level business cycles and constituent processes for article handling within museums</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={operationalService2} alt="operationalService2" className="img" /></div>
                        <li className="p-text">Organization structure for specific department with outlining of designation across all levels - senior to junior</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={operationalService3} alt="operationalService3" className="img" /></div>
                        <li className="p-text">Translate procedure for article handling, storage and maintenance into process flow maps and workflows</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={operationalService4} alt="operationalService4" className="img" /></div>
                        <li className="p-text">Roles and responsibilities, and authority matrix to demarcate decision-making across department</li>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 02 */}
      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Revamping the production planning process to improve delivery performance and reduce WIP</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">A manufacturer of refractory bricks in India catering to the requirements of the steel, cement, glass and other process industries.</li>
                  <li className="p-text">The company owned by the largest conglomerate in India before being acquired by a Japanese group</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">To improve product delivery performance, reduce WIP, and unlock latent capacity, with a focus on Dolomite refractories</li>
                  <li className="p-text">Introducing new processes and systems and facilitating their adoption</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">Diagnosed the production process and identified the change efforts needed</li>
                  <li className="p-text">Designed and implemented a new production plan applying principles and practices of the Theory of Constraints (TOC)</li>
                  <li className="p-text">Introduced target buffers for Dolomite Finished Goods and an attendant buffer management system </li>
                  <li className="p-text">Introduced new measurement and reward systems that incentivized changed behavior</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <div className="content key-project-content">
                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy2_img1} alt="operationalService5" className="img" /></div>
                        <li className="p-text">By revamping the production planning process using the Theory of Constraints, the team significantly improved OTIF from 36%
to 91%, directly contributing to a 45% increase in weekly sales and a 38% rise in total deliveries.</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy2_img2} alt="operationalService6" className="img" /></div>
                        <li className="p-text">The introduction of new measurement systems led to a 344% increase in net profit, improved capacity utilization by 33%, and
reduced operational costs by 12%, clearly linking operational discipline to financial gains.</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy2_img3} alt="operationalService7" className="img" /></div>
                        <li className="p-text">Profits of the dolomite business line increased by more than 4 times as a result of these improvements over 18 months.</li>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 03 */}
      <section className="case-study sec-padding border-bottom">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Creating a win-win in the distribution chain to achieve higher market share</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">The client is a locking solutions provider in India providing locks and allied security devices for residential, commercial and office spaces.</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">Improve on its stagnating market share in an increasingly competitive market</li>
                  <li className="p-text">Identify the cause of the lack of availability of the right products to sell at the right time to the distributors. </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">Mapped and analyzed the inventories held by distributors versus the actual demand and its impact on the sales of the company</li>
                  <li className="p-text">Designed and created a pull-based outbound supply chain to resolve the issues and create a win-win with the distributors</li>
                  <li className="p-text">Designed a pull system of inventory transfer from the production organization to the distributors to reduce slow-moving inventory </li>
                  <li className="p-text">Created a target buffer mechanism for Finished goods and buffer management-based production planning and execution on the shop floor.</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <div className="content key-project-content">
                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy3_img1} alt="operationalService8" className="img" /></div>
                        <li className="p-text">The shift to a pull-based inventory system and targeted buffer management led to a nearly 5X increase in weekly profits and
almost 4X improvement in annual cash flow, while cutting down inventory days by more than half—unlocking real value across the
distribution chain.</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy3_img2} alt="operationalService9" className="img" /></div>
                        <li className="p-text">A shift in the credit and supply model empowered distributors to stock smarter, sell more, and turn inventory over 4x
faster—resulting in a dramatic uplift in profitability</li>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={ops_casestudy3_img3} alt="operationalService10" className="img" /></div>
                        <li className="p-text">Market share increased from 32% to 41% during this period, and the company’s profits grew by more than 5 times—reflecting a
significant turnaround in performance.</li>
                      </div>
                    </div>
                  </div>
                  </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </Layout>
  );

}

